import { CRBTUICSSStyle, CRBTUICSSStyleImpl } from '../crbt/crbtuicss';

export interface BlacklistCSSStyle extends CRBTUICSSStyle
{
   
}

export class BlacklistCSSStyleImpl extends CRBTUICSSStyleImpl implements BlacklistCSSStyle
{
   
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/blacklist/blacklistcss.tsx